import type { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { ReactNode } from 'react'

import useDevice from '@/hooks/useDevice'

const TitleAndParagraph = ({
    title,
    paragraph,
    height = `100%`,
    sx,
    snippet,
    button,
}: {
    title: ReactNode
    paragraph: ReactNode
    snippet?: ReactNode
    height?: string
    sx?: SxProps
    button?: ReactNode
}) => {
    const { mdScreen } = useDevice()

    const isDesktop = !mdScreen

    return (
        <Box
            sx={{
                height,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                p: 0,
                ...sx,
            }}
        >
            <Box
                sx={{
                    p: 0,
                }}
            >
                <Text
                    variant={isDesktop ? `h4` : `h5`}
                    sx={{
                        mb: !mdScreen ? 6 : 3,
                        p: 0,
                    }}
                >
                    {title}
                </Text>
                <Text variant={isDesktop ? `body1` : `body2`}>{paragraph}</Text>
                {button && (
                    <Box
                        sx={{
                            width: '100%',
                            mt: !mdScreen ? 6 : 3,
                            textAlign: 'left',
                        }}
                    >
                        {button}
                    </Box>
                )}
                {snippet && (
                    <Box
                        sx={{
                            width: '100%',
                            mt: !mdScreen ? 6 : 3,
                            textAlign: 'left',
                        }}
                    >
                        {snippet}
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default TitleAndParagraph
